import mixin from '../mixins/child';

/**
 * @vue-prop {Boolean} activate - 활성화 유무
 * @vue-prop {String} tag - 컴포넌트 root tag
 * @vue-prop {String} onClass - 활성화 css class명
 * @vue-prop {String} hash - 해쉬값 e.g) #tab1
 */
export default {
  name  : 't-toggle-button',
  /**
   * @mixes Child
   */
  mixins: [mixin],
  props : {
    activate: {
      type   : Boolean,
      default: false
    },
    tag: {
      type   : String,
      default: 'button'
    },
    onClass: {
      type   : String,
      default: 'on'
    },
    hash: {
      type   : String,
      default: null
    }
  },
  mounted() {
    console.log('==mounted toggle ');

    this.checkActivate();
  },
  methods: {
    /**
     * 클릭 이벤트 핸들러
     * @param {Object} e
     */
    clickHandler(e) {
      this.$parent.change({
        index: this.index,
        hash : this.hash
      });

      if (e && this.tag === 'a') {
        e.preventDefault();
      }

      if (this.$listeners.click && e) {
        this.$listeners.click.fns(e);
      }
    },
    /**
     * 활성화 체크
     */
    checkActivate() {
      // props 에 activate 속성 존재 시 클릭 발생
      if (this.activate) {
        this.clickHandler();
      }

      // props 에 hash 가 등록 되어있을 때
      if (this.hash) {
        const regex = new RegExp(`${this.hash}`, 'g');

        // hash 값이 props에 등록된 hash와 동일하다면 클릭 발생
        if (regex.test(this.$route.hash)) {
          this.clickHandler();
        }
      }
    }
  },
  render(h) {
    return h(
      this.tag,
      {
        class: [
          't-toggle__button',
          { [this.calcOnClass]: this.index === this.selectedIndex }
        ],
        on: {
          ...this.$listeners,
          click: this.clickHandler
        }
      },
      this.$slots.default
    );
  }
};
